import SelectInput from "./SelectInput";
import { alertTypeLabelKey } from "config/constants";
import { eventTypeFilters } from "config/enabledModels";
import useTranslation from "hooks/useTranslation";
import { useMemo } from "react";
import { ModelTypes } from "types";

interface EventTypeFilterProps {
  models: ModelTypes[];
  value: string;
  onChange: (value: string) => void;
}

export default function EventTypeFilter({ models, value, onChange }: EventTypeFilterProps) {
  const t = useTranslation();
  const data = useMemo(() => {
    const allLabel = t["All event types"] || "All event types";
    return [
      { label: allLabel, value: "all" },
      ...eventTypeFilters(models).map((option) => {
        const labelKey = alertTypeLabelKey(option.models[0]);
        return { label: t[labelKey] || labelKey, value: option.value };
      })
    ];
  }, [models, t]);

  return (
    <SelectInput
      data={data}
      value={data.some((item) => item.value === value) ? value : "all"}
      onChange={(event) => onChange(String(event.target.value))}
      fullWidth
      helperText=""
      inputProps={{ "aria-label": t["Event Type"] || "Event Type" }}
    />
  );
}
